import {
    isCouponCodeAdded,
    ticketOrderSummary,
    transactionFeePercentage,
    transactionFeeText,
} from "@/app/events/[id]/store/buy-tickets.store";
import {useSignals} from "@preact/signals-react/runtime";
import {Separator} from "@radix-ui/react-dropdown-menu";

export const OrderSummary = () => {
    useSignals();
    const orderSummary = ticketOrderSummary.value;
    return (
        <>
            {orderSummary?.orderItems?.map((e) => (
                <div key={e.id} className="flex justify-between mb-2">
          <span>
            {e.quantity} x {e.title}
          </span>
                    <span>
            {orderSummary.currencyFormat} {e.totalPrice}
          </span>
                </div>
            ))}
            <div
                className="flex justify-between font-semibold mt-auto pt-8 pb-2 border-t border-gray-300 text-midnight-teal">
                <span>Total</span>
                <span>
          {orderSummary.currencyFormat} {orderSummary?.total}
        </span>
            </div>

            <div className="flex justify-between text-gray-500">
                {transactionFeePercentage.value ? (
                    <>
                        <span>
                          Transaction Fee ({transactionFeePercentage.value * 100}%)
                        </span>
                        <span>
                          {orderSummary.currencyFormat} {transactionFeeText.value}
                        </span>
                    </>
                ) : (
                    <span> No Transaction Fee</span>
                )}
            </div>

            {isCouponCodeAdded.value && (
                <>
                    <Separator className="my-1"/>
                    <div className="flex justify-between">
                        <span>Discount ({orderSummary?.discountText})</span>
                        <span>
              -{orderSummary.currencyFormat} {orderSummary?.discount}
            </span>
                    </div>
                </>
            )}

            <Separator className="my-4"/>
            <div className="flex justify-between font-bold">
                <span>Net</span>
                <span>
          {orderSummary.currencyFormat} {orderSummary?.netAmount}
        </span>
            </div>
        </>
    );
};
